<template>
  <div>
    <menu-pae :inFocus="false" :isVisible="false">
      <template>
        <div id="menuMesagem">
          <div class="acoes">
            <button class="btn btn-danger" @click.prevent="voltar"> Voltar </button>
            <button class="btn btn-primary" @click.prevent="salvar()"> Salvar </button>
          </div>
        </div>
      </template>
    </menu-pae>

    <div class="d-flex justify-content-center">
      <div class="row container">
        <div class="col-md-5 col-sm-12 text-sm-center">
          <nav aria-label="breadcrumb bg-white">
            <ol class="breadcrumb breadcrumb bg-white">
              <li class="breadcrumb-item"><router-link to="/workArea">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/caixa">Caixa de Mensagem</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ type }}</li>
            </ol>
          </nav>
        </div>
        <div class="col-12">
          <progressBar :progress="progess" :success="progessColor.success" :warning="progessColor.warning" class="mt-1 mb-3"/>
        </div>
      </div>
    </div>

    <alert-comp :msg="alert" />

    <div class="row">
      <div class="container mt-2">
        <div class="form-group row">

          <!-- Complemento -->
          <label for="" class="col-sm-2">Titulo: <span class="text-danger">*</span></label>
          <div class="col-md-10 col-sm-10">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.caixa.titulo.$error
            }">
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.caixa.titulo.$model"
              />
            </div>
            <div class="error" v-if="!$v.caixa.titulo.required">O campo é obrigatório</div>
          </div>

          <label for="" class="col-sm-2">Mensagem: <span class="text-danger">*</span></label>
          <div class="col-md-10 col-sm-10">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.caixa.mensagem.$error
            }">
              <textarea
                class="form-control"
                rows="3"
                v-model.trim="$v.caixa.mensagem.$model"
              />
            </div>
            <div class="error" v-if="!$v.caixa.mensagem.required">O campo é obrigatório</div>
          </div>

          <div class="col-sm-2">
            <label>Papel: <span class="text-danger">*</span></label>
          </div>
          <div class="col-sm-10">
            <div class="input-group">
              <select class="form-control center-select" v-model="$v.caixa.papel.$model">
                <option v-for="(item, indice) in tipoPapel" :key="indice" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>

          <label class="col-sm-2 mt-3">Período: </label>
          <div class="col-sm-10 mt-3">
            <div class="form-group input-group" :class="{
              'form-group--error': $v.caixa.periodo.$error
            }">
              <input v-model="$v.caixa.periodo.inicio.$model" type="date" class="form-control" placeholder="Período - Início">
              <input v-model="$v.caixa.periodo.fim.$model" type="date" class="form-control" placeholder="Período - Fim">
            </div>
            <div class="error" v-if="!$v.caixa.periodo.required">O campo é obrigatório</div>
            <div class="error" v-if="!$v.caixa.periodo.verifyPeriodo">A data de fim tem que ser maior ou igual ao do início</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuPae from '@/components/Menu.vue'
import progressBar from '@/components/progressBar/ProgressBar'

import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import md5 from 'md5'

import VirtusMensagemService from '@/services/VirtusMensagemService'
import alertComp from '@/components/alert/AlertComp'

export default {
  name: 'mensagem',

  components: {
    alertComp,
    menuPae,
    progressBar
  },

  created () {
    this.service = new VirtusMensagemService()

    this.identificador = this.$route.params.identificador
    this.type = this.identificador ? 'Editar Mensagem' : 'Nova Mensagem'
    if (this.identificador) {
      this.pesquisar()
    }
  },

  data () {
    return {
      caixa: {
        mensagem: '',
        titulo: '',
        papel: 'SEM PAPEL',
        periodo: {
          inicio: '',
          fim: ''
        }
      },
      tipoPapel: [
        { id: 0, text: 'TODOS', situacao: 'ATIVO', value: 'SEM PAPEL' },
        { id: 1, text: 'UNIDADE DE ARQUIVO DE PROTOCOLO', situacao: 'ATIVO', value: 'UNIDADE DE ARQUIVO DE PROTOCOLO' },
        { id: 2, text: 'UNIDADE DE PROTOCOLO', situacao: 'ATIVO', value: 'UNIDADE DE PROTOCOLO' },
        { id: 3, text: 'TÉCNICO DO SETOR', situacao: 'ATIVO', value: 'TÉCNICO DO SETOR' }
      ],
      alert: {
        texto: '',
        type: ''
      }
    }
  },

  validations: {
    caixa: {
      mensagem: {
        required
      },
      titulo: {
        required
      },
      papel: {
        required
      },
      periodo: {
        required (value) {
          if (value.inicio === '' || value.fim === '') {
            return false
          }

          return true
        },
        verifyPeriodo (value) {
          if (value.inicio === '' || value.fim === '') {
            return false
          }

          const inicio = new Date(value.inicio)
          const fim = new Date(value.fim)

          inicio.setHours(0, 0, 0, 0)
          fim.setHours(23, 59, 59, 0)

          if (inicio > fim) {
            return false
          }

          return true
        },
        inicio: {
          required
        },
        fim: {
          required
        }
      }
    }
  },

  computed: {
    ...mapState({
      progess (state) {
        var max = 3
        var count = 0
        count += this.$v.caixa.mensagem.$invalid ? 0 : 1
        count += this.$v.caixa.titulo.$invalid ? 0 : 1
        count += this.$v.caixa.periodo.$invalid ? 0 : 1

        return parseInt(count / max * 100)
      },
      progessColor (state) {
        var max = 3
        var count = 0
        count += this.$v.caixa.mensagem.$invalid ? 0 : 1
        count += this.$v.caixa.titulo.$invalid ? 0 : 1
        count += this.$v.caixa.periodo.$invalid ? 0 : 1

        if (count / max * 100 !== 100) {
          return {
            success: 'bg-danger',
            warning: 'bg-danger'
          }
        }

        return {
          success: 'bg-success',
          warning: 'bg-warning'
        }
      },
      securityKey () {
        const dateNow = new Date()
        const mensagem = this.caixa.mensagem
        const titulo = this.caixa.titulo
        const papel = this.caixa.papel
        const inicio = this.caixa.periodo.inicio
        const fim = this.caixa.periodo.fim
        return md5(dateNow + mensagem + titulo + papel + inicio + fim)
      }
    })
  },

  methods: {
    voltar () {
      this.$router.back()
    },

    limparDadosProcesso () {
      this.caixa.mensagem = ''
      this.caixa.titulo = ''
    },

    pesquisar () {
      this.service.getMensagens({
        identificador: this.identificador
      }).then(res => {
        const mensagem = res.data[0]
        if (mensagem) {
          const periodo = {
            inicio: mensagem.periodo.inicio.split('T')[0],
            fim: mensagem.periodo.fim.split('T')[0]
          }
          this.caixa = {
            mensagem: mensagem.texto,
            titulo: mensagem.titulo,
            papel: mensagem.destino.identificador,
            periodo: periodo
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },

    salvar () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      var destinos = [{
        titulo: this.caixa.papel,
        identificador: this.caixa.papel,
        tipoIdentificador: 'PAPEL'
      }]

      const dadosSessao = this.$store.getters.getDadosSessao.sessao
      const executor = {
        titulo: dadosSessao.nomeUsuario,
        identificador: dadosSessao.login,
        tipoIdentificador: 'LOGIN'
      }

      var body = {
        destino: destinos,
        executor,
        titulo: this.caixa.titulo,
        texto: this.caixa.mensagem,
        periodo: this.caixa.periodo
      }

      if (this.identificador) {
        body.destino = destinos[0]
        this.service.updateMensagem(this.identificador, body, this.securityKey).then(res => {
          this.alert.texto = 'Alterado com Sucesso!'
          this.alert.type = 'success'
        }).catch(err => {
          this.alert.texto = !err.response.data || !err.response.data.message ? 'Aconteceu algo com servidor.' : err.response.data.message
          this.alert.type = 'danger'
        })
      } else {
        this.service.createMensagem(body, this.securityKey).then(res => {
          this.$router.push({ name: 'Caixa Mensagem' })
        }).catch(err => {
          this.alert.texto = !err.response.data || !err.response.data.message ? 'Aconteceu algo com servidor.' : err.response.data.message
          this.alert.type = 'danger'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.acoes {
  display: flex;
  padding: 15px;
  position: absolute;

  .btn {
    margin-right: 10px;
    width: 150px;
    height: 28px;
  }
}

#dadosElaboracaoProcesso div{
  padding-bottom: 2px;
  padding-top: 2px;

  .btnInteressados {
    padding: 3px 18px;
    border-radius: 4px;
  }
}

.btn {
  //padding: 8px 16px;
  border-radius: 5px;
  &--primary {
    background-color: green;
    color: #fff;
  }
  &--secondary {
    background-color: #dddd;
    color: #000;
  }
}

.interesadoResumidos {
  background-color: white;
}

.interessadosHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: .75rem;
  background-color: rgba(213, 228, 251, 1);

  .titulo {
    color: #0962BD;
    margin: 10px;
  }

  i {
    color: red;
  }
}

.interessadosFooter {
  display: flex;
  justify-content: flex-end;

  .btn {
    margin-left: 5px;
    margin-right: 10px;
  }
}

.overflow-hidden {
  overflow: hidden;
}

.erro {
  color: orange;
}
</style>
